import { IGetBancosByIdFornecedorUseCase } from "../../../presentation/useCases/read/get_bancos_by_id_fornecedor_use_case";
import { FornecedorBanco } from "../../models/fornecedor_banco";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * GetBancosByIdFornecedorUseCase
 */

export class GetBancosByIdFornecedorUseCase implements IGetBancosByIdFornecedorUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async getBancosByIdFornecedor(
    idFornecedor: number | undefined,
  ): Promise<FornecedorBanco[]> {
    if (idFornecedor === undefined) throw new Error('Falha ao obter id do fornecedor!');
    return await this.repository.getBancosByIdFornecedor(idFornecedor);
  }
}
